// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AdminSidebar = registerClientReference(
    function() { throw new Error("Attempted to call AdminSidebar() from the server but AdminSidebar is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-sidebar.tsx",
    "AdminSidebar",
);
export const AdminSidebarNav = registerClientReference(
    function() { throw new Error("Attempted to call AdminSidebarNav() from the server but AdminSidebarNav is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-sidebar.tsx",
    "AdminSidebarNav",
);
export const getAdminNavItems = registerClientReference(
    function() { throw new Error("Attempted to call getAdminNavItems() from the server but getAdminNavItems is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-sidebar.tsx",
    "getAdminNavItems",
);
